import { createSelector } from "reselect";

import getDisplayItemsWithTextSizeMap from "./getDisplayItemsWithTextSizeMap";

/**
 * @param {TimelineRecord} state
 * @param {number} itemCardViewTextWidth
 * @param {boolean} isMobileMode
 */
export default createSelector(
  // input
  (state, itemCardViewTextWidth, isMobileMode = false, showDragHandles) =>
    getDisplayItemsWithTextSizeMap(state, itemCardViewTextWidth, isMobileMode, showDragHandles),
  // output
  displayItems => displayItems.toList()
);
